import { createTheme } from "@mui/material/styles";

/**
 * Usage        : ios Style Light theme for this App
 * Reference-1  : https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/color/
 * Reference-2  : https://material-ui.com/customization/default-theme/
 */
const MuiThemeLight = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1920,
    },
  },
  palette: {
    // dark/light mode
    mode: "light",
    // background-colors
    background: {
      default: "#FFF", //#f1f3f4
      paper: "#F5F5F7", // #fbfcfe
    },
    // primary-colors
    primary: {
      main: "#007AFF",
      light: "#419CFF",
      dark: "#0040DD",
      contrastText: "#FFF",
    },
    // secondary-colors
    secondary: {
      main: "#616161", // Standard gray
      light: "#BDBDBD", // Lighter gray
      dark: "#616161", // Darker gray
      contrastText: "#FFF", // Keeps white text for better readability
    },
    // error-colors
    error: {
      main: "#FF3B2F",
      light: "#FF6861",
      dark: "#D70015",
      contrastText: "#FFF",
    },
    // warning-colors
    warning: {
      main: "#FF9500",
      light: "#FFB33F",
      dark: "#A15901",
      contrastText: "#FFF",
    },
    // // info-colors
    // info: {
    //   main: "#5856D7",
    //   light: "#5856D7",
    //   dark: "#3634A3",
    //   contrastText: "#FFF"
    // },
    // // success-colors
    // success: {
    //   main: "#27CD41",
    //   light: "#32DE4B",
    //   dark: "#027D1B",
    //   contrastText: "#FFF"
    // },

    // info-colors
    info: {
      main: "#7c3aed",
      light: "#c4b5fd",
      dark: "#5b21b6",
      contrastText: "#FFF",
    },
    // success-colors
    success: {
      main: "#16a34a",
      light: "#86efac",
      dark: "#166534",
      contrastText: "#FFF",
    },
  },
});
export default MuiThemeLight;
